import React from "react";
import { Approved } from "components/Approved";

export const Notifications = () => {
  return <>{<Approved />}</>;
};
